import 'es5-shim'
import 'es6-shim'
import 'es6-promise/auto'
import 'fontawesome'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex/store'
import State from './vuex/state'
import axios from 'axios'

import VModal from 'vue-js-modal'

Vue.use(VModal)
// ElementUI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// ElementUIでの言語設定、datePickerとかで適用される
import locale from 'element-ui/lib/locale/lang/ja'

Vue.use(ElementUI, {locale})
import scrollState from '@/modules/scrollStatePlugin'
Vue.use(scrollState)
// Vue2-touch
import Vue2TouchEvents from 'vue2-touch-events'
Vue.use(Vue2TouchEvents)

Vue.config.productionTip = false
// errorHandler
Vue.config.errorHandler = function (err, vm, info) {
  console.error(vm)
  var text = '\n内容:' + err + '\n発生箇所:' + vm.$el.outerHTML + '近辺' + '\n:' + info
  text = text.replace(/"/g, '`')
  console.warn(text)
  const BASE_URL = `https://hooks.slack.com/services/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`
  const user = State.userInfo.fullname
  var now = new Date()
  var year = now.getFullYear()
  var mon = now.getMonth() + 1
  var day = now.getDate()
  var hour = now.getHours()
  var min = now.getMinutes()
  var sec = now.getSeconds()
  // 出力用
  var date = year + '年' + mon + '月' + day + '日' + hour + '時' + min + '分' + sec + '秒'
  const sendMesseage = 'フロントでエラー発生\n発生日時:' + date + '\n報告者:' + user + text
  let options = {
    method: 'post',
    baseURL: BASE_URL,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    },
    data: `payload={
        "text": "` + sendMesseage + `",
    }`
  }
  axios.request(options)
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,  // ルートインスタンスに注入すると、子コンポーネントで$storeを介してアクセスできる
  template: '<App/>',
  components: {
    'App': App
  }
})



// WEBPACK FOOTER //
// ./src/main.js